import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
  width: 60vw;
  height:40vh;
`;

export const TextArea = styled.textarea`
  font-size: max(6px, 1vw);
  color: ${theme.colors.dark};
  border: solid 0.6px ${theme.colors.dark};
  padding: 2vh 1vw;
  width: 100%;
  height: 40vh;

  resize: none;
`;

export const DivHandleButton = styled.div`

  display: flex;
  align-items: center;
  width:100%;

`;
export const SubmitButton = styled.button`
  background-color: ${theme.colors.darkGrey};
  &:hover {
    opacity: 0.7;
  }
  font-size: max(6px, 1vw);
  font-weight: bold;
  color: ${theme.colors.light};

  padding: 0.6vh 1.2vw;
  border-radius: 0.25rem;
  margin:auto;
  margin-top:1vh;
`;
